module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="desktop" class="task-panel">\n    <div id="desktop-image"></div>\n    <div id="desktop-image-mask"></div>\n    <div class="shortcutsContainers">\n    </div>\n</div>\n\n';

}
return __p
}